import Icon from '@vfz/ui/dist/components/icon/icon';
import { SupportCaseStatus } from 'api/support-case.types';
import React from 'react';
import { ContentUtil } from 'utils';

import content from './support-case-status.content';

const contentUtil = new ContentUtil({ content, componentName: 'SupportCaseStatus' });

const formatSupportCaseStatusUtil = (status: SupportCaseStatus) => {
  const { OPEN, CLOSED, AWAITING_RESPONSE } = SupportCaseStatus;

  const formattedSupportCases = {
    [OPEN]: {
      icon: <Icon name="time" variant="solid" width={14} height={14} />,
      value: contentUtil.translateToString(OPEN),
    },
    [CLOSED]: {
      icon: <Icon name="lockLocked" variant="solid" width={14} height={14} />,
      value: contentUtil.translateToString(CLOSED),
    },
    [AWAITING_RESPONSE]: {
      icon: <Icon name="time" variant="solid" width={14} height={14} />,
      value: contentUtil.translateToString(AWAITING_RESPONSE),
    },
  };

  return (
    <>
      {formattedSupportCases[status].icon} {formattedSupportCases[status].value}
    </>
  );
};

export default formatSupportCaseStatusUtil;
